import React from 'react';
import { useStore, useStorePrimitive, useActions } from '../../hooks/useStore';
import GridSettingsModal from './GridSettingsModal';
import type { GridSettings } from '../../types/types';

interface GridSettingsModalContainerProps {
  isOpen: boolean;
  onClose: () => void;
}

/**
 * Container for GridSettingsModal (ADR-034).
 * Owns store access for activeMapId, grid settings, and the updateGridSettings action.
 */
const GridSettingsModalContainer: React.FC<GridSettingsModalContainerProps> = ({ isOpen, onClose }) => {
  const activeMapId = useStorePrimitive(state => state.session?.map?.activeMapId);
  const gridSettings: Record<string, GridSettings> = useStore(state => state.settings?.grids);
  const actions = useActions();

  const handleUpdateGridSettings = (mapId: number, settings: GridSettings) => {
    actions.updateGridSettings(mapId, settings);
  };

  return (
    <GridSettingsModal
      isOpen={isOpen}
      onClose={onClose}
      activeMapId={activeMapId}
      gridSettings={gridSettings}
      onUpdateGridSettings={handleUpdateGridSettings}
    />
  );
};

export default GridSettingsModalContainer;
